import { Dialog, TablePagination } from "@mui/material";
import styles from "./smartdevices.module.css";
import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import { TableLoader } from "../../../../../components/LoaderC";
import DeviceCard from "./components/DeviceCard";
import DeviceFilter from "./components/DeviceFilter";
import AddDeviceForm from "./components/AddDeviceForm";
import AddLockForm from "./components/AddLockForm";

const SmartDevices = ({ tenantData, setLoading, setSnackbarOpen, setSnackbarMsg }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [contentLoading, setContentLoading] = useState(true);
    const [deviceAllList, setDeviceAllList] = useState([]);
    const [deviceList, setDeviceList] = useState([]);
    const [page, setPage] = useState(0);
    const [perPage, setPerPage] = useState(6);
    const [filterData, setFilterData] = useState({ searchKey: "", product: "", location: "", status: "" });
    const [showAddFormNew, setShowAddFormNew] = useState(false);
    const [showAddFormNew2, setShowAddFormNew2] = useState(false);

    useEffect(() => {
        const fetchDevices = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            axios(process.env.REACT_APP_TENANT_API_URL + "v1/devices/" + tenantData?.apt_id, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setContentLoading(false);

                setDeviceAllList(response.data.data);
            }).catch((error) => {
                setContentLoading(false);
            });
        }

        if (tenantData?.apt_id) {
            fetchDevices();
        }
    }, [tenantData, getAccessTokenSilently]);

    useEffect(() => {
        let filteredList = deviceAllList;

        if (filterData.searchKey !== "") {
            let inputVal = filterData.searchKey.toLowerCase();

            filteredList = filteredList.filter((item) => {
                const aptMatch = item?.apartment?.apt_no?.toLowerCase().includes(inputVal);
                const locMatch = item?.location?.toLowerCase().includes(inputVal);
                const nameMatch = item?.name?.toLowerCase().includes(inputVal);
                const typeMatch = item?.product_type?.toLowerCase().includes(inputVal);
                const propMatch = item?.property?.name?.toLowerCase().includes(inputVal);
                const realNameMatch = item?.real_name?.toLowerCase().includes(inputVal);

                const keyfobMatch = Array.isArray(item?.keyfobs) && item.keyfobs.some((kf) => kf.toString().toLowerCase().includes(inputVal));

                return (aptMatch || locMatch || nameMatch || typeMatch || propMatch || realNameMatch || keyfobMatch);
            });
        }

        if (filterData.status !== "" && filterData.status !== "all") {
            filteredList = filteredList.filter((i) => i.online === parseInt(filterData.status));
        }

        if (filterData.location !== "" && filterData.location !== "all") {
            filteredList = filteredList.filter((i) => i.location === filterData.location);
        }

        if (filterData.product !== "" && filterData.product !== "all") {
            filteredList = filteredList.filter((i) => i.product_type === filterData.product);
        }

        setDeviceList(filteredList);

    }, [deviceAllList, filterData]);

    const onAdd = (data) => {
        setDeviceAllList((prev) => {
            return data.concat(prev);
        });
    }

    return <>
        {contentLoading && (<div className="Loader TableLoader">
            <TableLoader />
        </div>)}

        {!contentLoading && <>

            <DeviceFilter filterData={filterData} setFilterData={setFilterData.bind(this)} setShowAddFormNew={setShowAddFormNew.bind(this)} setShowAddFormNew2={setShowAddFormNew2.bind(this)} />

            <div className={`${styles.SmartDeviceRow}`}>

                {deviceList.length > 0 && deviceList.map((item, index) => {
                    return perPage === -1 || (index >= page * perPage && index < page * perPage + perPage) ? (<DeviceCard item={item} />) : null;
                })}

                {deviceList.length > 0 && (<div className="Pagination TablePaginationNew List">
                    <TablePagination
                        count={deviceList.length}
                        color="primary"
                        page={page}
                        rowsPerPage={perPage}
                        onPageChange={(e, v) => setPage(v)}
                        rowsPerPageOptions={[
                            { label: "6", value: 6 },
                            { label: "12", value: 12 },
                            { label: "18", value: 18 },
                            { label: "All", value: -1 },
                        ]}
                        onRowsPerPageChange={(e) => {
                            setPage(0);
                            setPerPage(e.target.value);
                        }}
                        labelRowsPerPage={"Devices per Page:"}
                    />
                </div>)}

                {deviceList.length === 0 && (<div className={`${styles.NoDataMain}`}>
                    <div className={`${styles.NoDataIMG}`}>
                        <img src="/static/img/noDevice.svg" alt="No Data" />
                    </div>
                    <p className={`${styles.NoDataText}`}>Let's fill it up!</p>
                    <p className={`${styles.NoDataTextSub}`}>Device List is Currently Empty.</p>
                </div>)}

            </div>
        </>}

        <Dialog
            open={showAddFormNew}
            onClose={(e) => { setShowAddFormNew(false); }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp MobileForm CustomWidthPops"
        >
            <AddDeviceForm
                setShowAddFormNew={setShowAddFormNew.bind(this)}
                setSnackbarOpen={setSnackbarOpen.bind(this)}
                setSnackbarMsg={setSnackbarMsg.bind(this)}
                setLoading={setLoading.bind(this)}
                tenantData={tenantData}
                onSubmitLocal={onAdd.bind(this)}
            />
        </Dialog>

        <Dialog
            open={showAddFormNew2}
            onClose={(e) => { setShowAddFormNew2(false); }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp MobileForm CustomWidthPops"
        >
            <AddLockForm
                setShowAddFormNew={setShowAddFormNew2.bind(this)}
                setSnackbarOpen={setSnackbarOpen.bind(this)}
                setSnackbarMsg={setSnackbarMsg.bind(this)}
                setLoading={setLoading.bind(this)}
                tenantData={tenantData}
                onSubmitLocal={onAdd.bind(this)}
            />
        </Dialog>
    </>;
}

export default SmartDevices;